(ns frontend.view.modals.new-kpi-cycle.events
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]
   [potpuri.core :as potpuri :refer [fn-> fn->>]]
   [frontend.logging :as logging]))

(defn reset-state!
  [state members]
  (let [member-confirms (->> members
                             #_(map (juxt :db/id
                                          (fn-> :kpi-member/status
                                                #_(= :kpi-member.status/paused)
                                                not)))
                             (map (fn [m]
                                    [(:db/id m)
                                     (not= (:kpi-member/status m) :kpi-member.status/paused)]))
                             (into {}))
        ;;all kpi-members included into kpi-cycle if not in state
        ;;    :kpi-member.state/paused
        confirms {:confirm member-confirms}]
    (reset! state confirms)))

(defn set-alert!
  [state text]
  (swap! state assoc :alert text))

(defn hide-alert!
  [state]
  (swap! state dissoc :alert))

(defn set-ready!
  [state]
  (swap! state assoc :ready? true :error? false :processing? false))

(defn set-error!
  [state]
  (swap! state assoc :error? true :ready? false :processing? false))

(defn back!
  [state]
  (swap! state assoc :error? false :ready? false :processing? false))

(defn create-cycle!
  [state category close!]
  (let [{:keys [kpi-cycle/target-month kpi-cycle/target-year]} (:edit @state)
        confirms (->> @state
                      :confirm
                      (filter second)
                      (map first)
                      vec)
        email-option (-> @state
                         :email-option
                         (or :now))
        msg {:category-id      (:db/id category)
             :email-option     email-option
             :kpi-cycle        {:target-month target-month
                                :target-year  target-year}
             :included-members confirms}]
    (swap! state assoc :processing? true)
    (-> (conn/sendp! :kpi-category/add-cycle
                     msg)
        (p/then (fn [_]
                  (js/setTimeout (fn []
                                   (set-ready! state))
                                 2000)))
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! state))
                   (js/setTimeout (fn []
                                    (set-error! state))
                                  1000)
                   (logging/error "create-kpi-cycle! " e))))))
